import { Grid, Paper } from "@material-ui/core";
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import { debounce, orderBy } from "lodash";
import { memo } from "react";
import { arrayMove, sortableContainer, sortableElement, sortableHandle } from 'react-sortable-hoc';
import { FormConditionsContainer } from "../FormConditions/FormConditions";
import { FormBuilderStyles } from "../style";
import FormQuestion from "./FormQuestion";
import { QuestionActions } from "./QuestionActions";

import { questionTypes } from "../formBuilderConsts";

const FormQuestions = ({
    form,
    questions,
    onFormFieldChange,
    onQuestionsChange,
    onDeleteQuestion,
    onDuplicateQuestion,
    mappedFieldsUsed
}) => {

    const classes = FormBuilderStyles();

    const elementTypes = {
        question: 1,
        section: 2
    }

    const questionsSorted = orderBy(questions ?? form.questions ?? [], 'order');

    const onQuestionChange = (index, question) => {
        questionsSorted[index] = question;
        onQuestionsChange(questionsSorted)
    }

    const onSortEnd = ({ oldIndex, newIndex }) => {
        onQuestionsChange(arrayMove(questionsSorted, oldIndex, newIndex).map((q, index) => ({ ...q, order: index })))
    };

    return (
        <SortableContainer onSortEnd={onSortEnd} useDragHandle>
            {questionsSorted.map((q, index) => (
                <SortableItem
                    index={index}
                    question={q}
                    questionIndex={index}
                    onQuestionChange={onQuestionChange}
                    form={form}
                    onDeleteQuestion={onDeleteQuestion}
                    onDuplicateQuestion={onDuplicateQuestion}
                    mappedFieldsUsed={mappedFieldsUsed}
                    allQuestions={questionsSorted}
                />
            ))}
        </SortableContainer>
    );
}
export default memo(FormQuestions);


const SortableItem = sortableElement(({ question, questionIndex, onQuestionChange, form, onDeleteQuestion, onDuplicateQuestion, mappedFieldsUsed, allQuestions }) => {
    const classes = FormBuilderStyles();


    const questionTypesForConditions = [
        questionTypes.Dropdown,
        questionTypes.MultipleChoice,
    ];

    let questionsForConditions = allQuestions?.filter(q => questionTypesForConditions?.includes(q.questionType) && q.id > 0);

    const onChange = (question) => {
        onQuestionChange(questionIndex, question);
    };

    const DragHandle = sortableHandle(() => <div className={classes.dragHandler}>
        <DragIndicatorIcon className={classes.dragIconQuestion} color="secondary" />
    </div>);
    return <Grid item>
        <Paper >
            <DragHandle />
            <div className={classes.questionContainer}>
                <FormQuestion question={question} form={form} onChange={onChange} mappedFieldsUsed={mappedFieldsUsed} />
                <FormConditionsContainer
                    questionsForConditions={questionsForConditions}
                    currentQuestion={question}
                    onQuestionChange={onChange}
                />
            </div>
            <QuestionActions
                onDeleteQuestion={onDeleteQuestion}
                onDuplicateQuestion={onDuplicateQuestion}
                questionIndex={questionIndex}
                question={question}
                onQuestionChange={onQuestionChange}
            />
        </Paper>
    </Grid>
});

const SortableContainer = sortableContainer(({ children }) => {
    const classes = FormBuilderStyles();
    return <Grid container direction="column" spacing={1} className={classes.questionsContainer}>
        {children}
    </Grid>;
});

